export function formatXafNumber(value: number): string {
  return value.toLocaleString("fr-FR");
}

export function formatXaf(value: number): string {
  return `${formatXafNumber(value)} XAF`;
}
